import type { Extensions } from '@tiptap/core'
import Image from '@tiptap/extension-image'
import type { MentionOptions } from '@tiptap/extension-mention'
import StarterKit from '@tiptap/starter-kit'
import { PostMention } from './mention-extension'

export interface CreatePostExtensionsOptions {
  mentionSuggestion?: MentionOptions['suggestion']
}

export const createPostExtensions = ({
  mentionSuggestion,
}: CreatePostExtensionsOptions = {}): Extensions => [
  StarterKit.configure({
    heading: false,
    code: false,
    codeBlock: false,
    blockquote: false,
    horizontalRule: false,
    hardBreak: false,
    trailingNode: false,
    strike: false,
    bulletList: { HTMLAttributes: { class: 'list-disc ps-5' } },
    orderedList: { HTMLAttributes: { class: 'list-decimal ps-5' } },
    link: {
      openOnClick: false,
      autolink: false,
      HTMLAttributes: { target: '_blank' },
    },
  }),
  Image.configure({ inline: false, allowBase64: false }),
  PostMention.configure({
    HTMLAttributes: { class: 'mention' },
    suggestion: mentionSuggestion,
  }),
]
